import React, { useState } from 'react';
import './FAQs.css';

const FAQs = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "What can I expect during my first session?",
      answer: "Your first session is an opportunity for us to get to know each other. I'll ask about what brings you to therapy, your background, and your goals. We'll discuss how we can work together and address any questions you might have about the process."
    },
    {
      question: "How long are therapy sessions?",
      answer: "Standard therapy sessions are 50 minutes long. However, I also offer extended sessions (90 minutes) for clients who need more time to work through complex issues or prefer longer sessions."
    },
    {
      question: "How often should I attend therapy?",
      answer: "Most clients start with weekly sessions, which provides consistent support and momentum for change. As you progress, we may reduce frequency to bi-weekly or monthly sessions. The frequency is always tailored to your needs and goals."
    },
    {
      question: "Do you accept insurance?",
      answer: "Please contact me for more information about insurance coverage."
    },
    {
      question: "What is your cancellation policy?",
      answer: "I require 24 hours notice for session cancellations. Sessions cancelled with less than 24 hours notice may be charged the full session fee. I understand that emergencies happen, and I'm always willing to discuss extenuating circumstances."
    },
    {
      question: "How long does therapy typically take?",
      answer: "The duration of therapy varies greatly depending on your goals and the issues you're working through. Some clients achieve their goals in just a few sessions, while others benefit from longer-term therapy. We'll regularly review your progress and adjust our approach accordingly."
    },
    {
      question: "Is therapy confidential?",
      answer: "Yes, therapy is confidential. However, there are legal exceptions to confidentiality, including situations involving harm to self or others, child abuse, or elder abuse. I'll discuss these exceptions with you during our first session."
    },
    {
      question: "Do you offer in-person sessions?",
      answer: "No, at this time I only offer virtual sessions. Virtual sessions are conducted through a secure, HIPAA-compliant platform. Many clients find virtual therapy to be just as effective as in-person sessions and appreciate the convenience. I do offer on-site services for organizations that are interested in psychoeducation around grief and loss."

    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faqs">
      <div className="faqs-container">
        <div className="faqs-header">
          <h1>Frequently Asked Questions</h1>
          <p>
            I understand that starting therapy can raise many questions. Here are answers to some 
            of the most common questions I receive. If you don't see your question answered here, 
            please don't hesitate to reach out.
          </p>
        </div>
        
        <div className="faqs-list">
          {faqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <button 
                className={`faq-question ${openIndex === index ? 'active' : ''}`}
                onClick={() => toggleFAQ(index)}
              >
                {faq.question}
                <span className="faq-toggle">
                  {openIndex === index ? '−' : '+'}
                </span>
              </button>
              <div className={`faq-answer ${openIndex === index ? 'active' : ''}`}>
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
        
        <div className="faqs-contact">
          <h2>Still Have Questions?</h2>
          <p>
            If you have additional questions or would like to discuss how I can help you, 
            I'm here to help. Feel free to reach out for a free consultation call.
          </p>
          <a href="/contact" className="contact-button">Contact Me</a>
        </div>
      </div>
    </div>
  );
};

export default FAQs;
